import _ from 'lodash';

import '../styles/rooms-browser.less';

angular.module('cian.roomsBrowser')
  .directive('roomsBrowser', function () {
    return {
      scope: {},
      template: require('../../templates/rooms-browser.html'),
      restrict: 'E',
      controller: [
        '$scope',
        'FilterService',
        'FilterTermsService',
        function ($scope, FilterService, FilterTermsService) {
          const ctrl = this;

          ctrl.isPopupOpen = false;
          ctrl.openPopup = () => ctrl.isPopupOpen = !ctrl.isPopupOpen;
          ctrl.closePopup = () => ctrl.isPopupOpen = false;

          ctrl.room = FilterService.filter.room;
          $scope.$watch(() => FilterService.filter.room, newVal => ctrl.room = newVal);

          const saleRoomTypes = FilterTermsService.roomTypes;
          // Свободный план — только для продажи
          const rentRoomTypes = _.reject(saleRoomTypes, room => room.value === 7);
          ctrl.getRoomTypes = () =>
            FilterService.dealTypeIs('rent') ? rentRoomTypes : saleRoomTypes;

          const roomsTitles = {
            9: 'студию',
            7: 'своб. план.'
          };

          ctrl.getTitle = () => {
            const rooms = ctrl.room.value;

            if (rooms && rooms.length) {
              let result = '';
              const roomNumbers = [];
              const otherRooms = [];

              angular.forEach(rooms, function (roomValue) {
                if (roomValue <= 6) {
                  roomNumbers.push(roomValue === 6 ? '6+' : roomValue);
                } else {
                  otherRooms.push(roomsTitles[roomValue]);
                }
              });

              if (roomNumbers.length) {
                roomNumbers.sort();
                result += roomNumbers.join(',') + ' ';
                result += rooms.length <= 2 ? 'комн.' : 'к.';
              }

              if (otherRooms.length) {
                result += result ? ', ' : '';
                result += otherRooms.join(', ');
              }

              return result[0].toUpperCase() + result.substr(1);
            } else {
              return 'Комнат';
            }
          };
        }],
      controllerAs: 'roomsBrowser',
    };
  });



// WEBPACK FOOTER //
// ./src/components/rooms-browser/src/scripts/cian.rooms-browser.dir.js